import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../lib/useAuth'
import AuthLayout, { Field, SubmitButton, Notice } from '../components/AuthLayout'

/** /forgot-password — email → send a reset link (→ /reset-password). */
export default function ForgotPassword() {
  const auth = useAuth({ mode: 'forgot' })
  const [email, setEmail] = useState('')

  return (
    <AuthLayout
      gauge
      title="Reset your password"
      subtitle="Enter your email and we’ll send you a link to set a new password."
    >
      <Notice notice={auth.notice} />
      <form onSubmit={(e) => { e.preventDefault(); auth.sendReset({ email }) }}>
        <Field
          label="Email" name="email" type="email" value={email} onChange={setEmail}
          placeholder="you@company.com" autoComplete="email" required autoFocus disabled={!auth.configured}
        />
        <SubmitButton busy={auth.busy} disabled={!auth.configured} busyLabel="Sending…">Send reset link</SubmitButton>
      </form>

      {!auth.configured && (
        <p className="rrauth__notice rrauth__notice--info" style={{ marginTop: 16 }}>
          Password reset isn’t configured in this build.
        </p>
      )}

      <p className="rrauth__back">
        <Link className="rrauth__link" to="/signin">← Back to sign in</Link>
      </p>
    </AuthLayout>
  )
}
